import { Nilable } from "@shared/utils";

export interface IPremioLimiteDTO {
    daily_limit: number;
    remaining_limit: number;
    updated_at: string;
}

export class PremioLimiteDTO {
    public limiteDiario = 0;
    public disponible = 0;
    public actualizadoEl = "";

    constructor(json: Nilable<Partial<IPremioLimiteDTO>> = null) {
        if (json != null) {
            this.cargarDTO(json);
        }
    }

    public cargarDTO(json: Partial<IPremioLimiteDTO>) {
        if (json.daily_limit) {
            this.limiteDiario = json.daily_limit;
        }
        if (json.remaining_limit) {
            this.disponible = json.remaining_limit;
        }
        if (json.updated_at) {
            this.actualizadoEl = json.updated_at;
        }
    }

    public toJSON(): IPremioLimiteDTO {
        return {
            daily_limit: this.limiteDiario,
            remaining_limit: this.disponible,
            updated_at: this.actualizadoEl
        };
    }
}
